export default __webpack_public_path__ + "static/media/linkedin.f48b4b0a.svg";